import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { validation } from "../utils/validation";
import bsCustomFileInput from "bs-custom-file-input";
import "../styles/styles.scss";
import { Form, Row, Col, Card, Button, FormControl } from "react-bootstrap";
import { onSubmit } from "../utils/onSubmit";
import {
	handleDocExtensions,
	handleFileExtensions,
	handleFileSize,
	handleImageExtensions,
	handleFileSizeMin,
} from "../utils/filesHandlers";
import { ModalPayment } from "./ModalPayment";
import { Link } from "react-router-dom";
import { Loading } from "./Loading";

export function FormTransport({ match }) {
	const { bromatologico } = match.params;
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm({
		resolver: yupResolver(validation),
	});
	const [loading, setLoading] = useState();
	const [data, setData] = useState();

	useEffect(() => {
		bsCustomFileInput.init();

		if (localStorage.getItem("data")) {
			let dataStorage = localStorage.getItem("data");
			setData(JSON.parse(dataStorage));
		}
	}, []);
	const onsumbit = async (data) => {
		await onSubmit(data, setLoading);
	};

	if (loading) {
		return <Loading />;
	}

	return (
		<div className="container mt-5 mb-5 form">
			<Form onSubmit={handleSubmit(onsumbit)}>
				<Card className="shadow mb-5 bg-white rounded">
					<Card.Header className="text-uppercase text-center">
						Datos del titular del vehículo.
					</Card.Header>
					<Card.Body>
						<Form.Group>
							<Row className="mb-2">
								<Col sm={12} md={6} className="mb-2">
									<Form.Label className="text-uppercase">Nombre</Form.Label>
									<Form.Control
										name="firstname"
										{...register("firstname")}
										isInvalid={!!errors.firstname}
									/>
									<Form.Control.Feedback type="invalid">
										{errors.firstname?.message}
									</Form.Control.Feedback>
								</Col>
								<Col sm={12} md={6}>
									<Form.Label className="text-uppercase">Apellido</Form.Label>
									<Form.Control
										name="lastname"
										{...register("lastname")}
										isInvalid={!!errors.lastname}
									/>
									<Form.Control.Feedback type="invalid">
										{errors.lastname?.message}
									</Form.Control.Feedback>
								</Col>
							</Row>
							<Row className="mb-2">
								<Col sm={12} md={6}>
									<Form.Label>N° DE DNI</Form.Label>
									<Form.Control
										name="dni"
										{...register("dni")}
										isInvalid={!!errors.dni}
									/>
									<Form.Control.Feedback type="invalid">
										{errors.dni?.message}
									</Form.Control.Feedback>
								</Col>
								<Col sm={12} md={6} className="d-flex align-items-end">
									<Form.File
										onInput={(e) => {
											handleDocExtensions(e);
											handleFileSizeMin(e);
										}}
										className="text-uppercase"
										name="DNIpdf"
										label="copia DNI en pdf"
										custom
										id="input-file1"
										data-browse="Adjuntar"
										accept="application/pdf"
										{...register("DNIpdf")}
									/>
								</Col>
							</Row>
							<Row className="mb-2">
								<Col sm={12} md={6}>
									<Form.Label>N° DE CUIT</Form.Label>
									<Form.Control
										name="cuit"
										{...register("cuit")}
										isInvalid={!!errors.cuit}
									/>
									<Form.Control.Feedback type="invalid">
										{errors.cuit?.message}
									</Form.Control.Feedback>
								</Col>
								<Col sm={12} md={6} className="d-flex align-items-end">
									<Form.File
										onInput={(e) => {
											handleDocExtensions(e);
											handleFileSizeMin(e);
										}}
										className="text-uppercase"
										name="afip"
										label="inscripción en afip."
										custom
										data-browse="Adjuntar"
										accept="application/pdf"
										{...register("afip")}
									/>
								</Col>
							</Row>

							<Row className="mb-2">
								<Col sm={12} md={6} className="mt-3">
									<Form.Label className="text-uppercase">
										Domicilio Real
									</Form.Label>
									<Form.Control
										name="address"
										{...register("address")}
										isInvalid={!!errors.address}
									/>
									<Form.Control.Feedback type="invalid">
										{errors.address?.message}
									</Form.Control.Feedback>
								</Col>
								<Col sm={12} md={6} className="mb-sm-3 mt-3">
									<Form.Label className="text-uppercase">
										Domicilio Electrónico
									</Form.Label>
									<Form.Control
										name=""
										type="email"
										{...register("email")}
										isInvalid={!!errors.email}
									/>
									<Form.Control.Feedback type="invalid">
										{errors.email?.message}
									</Form.Control.Feedback>
								</Col>
							</Row>
							<Row className="mb-2">
								<FormControl
									aria-label="Text input with checkbox"
									defaultValue="PERSONA JURÍDICA (DE CORRESPONDER)"
									name="legalPerson"
									readOnly
								/>
								<Col sm={12} className="mt-3">
									<Form.File
										onInput={(e) => {
											handleFileExtensions(e);
											handleFileSize(e);
										}}
										multiple
										className="text-uppercase"
										name="legalPerson"
										label="documentación que respalde la personeria invocada (poder, estatutos, contrato social, etc)"
										custom
										data-browse="Adjuntar"
										accept="application/pdf,.jpg,.png"
										{...register("legalPerson")}
									/>
								</Col>
							</Row>
						</Form.Group>
					</Card.Body>
				</Card>

				<Card className="shadow bg-white rounded">
					<Card.Header className="text-uppercase text-center">
						Datos del Vehículo
					</Card.Header>
					<Card.Body>
						<Form.Group>
							<Row className="mb-4">
								<Col sm={12} md={6}>
									<Form.Label>DOMINIO</Form.Label>
									<Form.Control
										name="domain"
										label="sin espacios o guiones"
										pattern="[a-zA-Z0-9]{6,7}"
										title="SIN ESPACIOS NI GUIONES"
										{...register("domain")}
										isInvalid={!!errors.domain}
									/>
									<Form.Control.Feedback type="invalid">
										{errors.domain?.message}
									</Form.Control.Feedback>
								</Col>
							</Row>
							<Row sm={12} md={10}>
								<Col sm={12} md={6} className=" d-flex align-items-end">
									<Form.File
										onInput={(e) => {
											handleDocExtensions(e);
											handleFileSizeMin(e);
										}}
										className="text-uppercase"
										name="deedpdf"
										label="copia del titulo en pdf"
										custom
										data-browse="Adjuntar"
										accept="application/pdf"
										{...register("deedpdf")}
									/>
								</Col>

								<Col className="">
									<Form.File
										onInput={(e) => {
											handleDocExtensions(e);
											handleFileSizeMin(e);
										}}
										className="text-uppercase"
										name="VTVpdf"
										label="copia VTV VIGENTE en pdf"
										custom
										data-browse="Adjuntar"
										accept="application/pdf"
										{...register("VTVpdf")}
									/>
								</Col>
							</Row>
							<Row className="mb-2">
								<Col className="mt-3">
									<Form.Label className="text-uppercase">
										Seguro de Responsabilidad Civil
									</Form.Label>
								</Col>
							</Row>
							<Row>
								<Col sm={12} md={6} className="mb-2">
									<Form.File
										onInput={(e) => {
											handleDocExtensions(e);
											handleFileSizeMin(e);
										}}
										className="text-uppercase"
										name="policy"
										label="copia de la poliza vigente en pdf"
										custom
										data-browse="Adjuntar"
										accept="application/pdf"
										{...register("policy")}
									/>
								</Col>
								<Col sm={12} md={6} className="mb-2">
									<Form.File
										onInput={(e) => {
											handleFileExtensions(e);
											handleFileSizeMin(e);
										}}
										className="text-uppercase"
										name="payment"
										label="comprobante de pago seguro"
										custom
										accept="application/pdf,.jpg,.png"
										data-browse="Adjuntar"
										{...register("payment")}
									/>
								</Col>
							</Row>
						</Form.Group>
						<Form.Group>
							<Row className="mb-2">
								<Col className="mt-3">
									<Form.Label className="text-uppercase">
										Fotografias del vehículo
									</Form.Label>
								</Col>
							</Row>
							<Row className="mb-2 ">
								<Col sm={12} md={6} className="mb-2">
									<Form.File
										onInput={(e) => {
											handleImageExtensions(e);
											handleFileSizeMin(e);
										}}
										className="text-uppercase"
										name="imgFront"
										label="frente en formato jpg o png"
										custom
										data-browse="Adjuntar"
										accept=".jpg,.png"
										{...register("imgFront")}
									/>
								</Col>{" "}
							</Row>
							<Row className="mb-2 ">
								<Col sm={12} md={6} className="mb-2 ">
									<Form.File
										onInput={(e) => {
											handleImageExtensions(e);
											handleFileSizeMin(e);
										}}
										className="text-uppercase"
										name="imgSide"
										label="perfil en formato jpg o png"
										custom
										data-browse="Adjuntar"
										accept=".jpg,.png"
										{...register("imgSide")}
									/>
								</Col>
							</Row>
							<Row className="mb-2 ">
								<Col sm={12} md={6} className="mb-2">
									<Form.File
										onInput={(e) => {
											handleImageExtensions(e);
											handleFileSizeMin(e);
										}}
										className="text-uppercase"
										name="imgBack"
										label="parte trasera en formato jpg o png"
										custom
										data-browse="Adjuntar"
										accept=".jpg,.png"
										{...register("imgBack")}
									/>
								</Col>
							</Row>
						</Form.Group>
					</Card.Body>
				</Card>
				<Card className="shadow mb-5 bg-white rounded">
					<Card.Header className="text-uppercase text-center">
						Categoría del vehículo
					</Card.Header>
					<Card.Body>
						<Form.Group>
							<Row className="mb-2">
								<Col>
									{bromatologico ? (
										<Form.Control
											className="text-uppercase"
											as="select"
											name="category"
											{...register("category")}>
											<option>
												A. Caja contenedor o cisterna con aislamiento térmico y
												con equipo mecánico de frio.
											</option>
											<option>
												B.Caja contenedor o cisterna con aislamiento térmico y
												sin equipo mecánico de frio, y con sistemas
												refrigerantes autorizados por la Autoridad Sanitaria.
											</option>
											<option>
												C.Caja contenedor o cisterna con aislamiento térmico y
												sin equipo mecánico de frio y sin sistemas
												refrigerantes.
											</option>
											<option>D. Caja sin aislamiento térmico.</option>
											<option>E. Sin caja o playo.</option>
										</Form.Control>
									) : (
										<Form.Control
											className="text-uppercase"
											as="select"
											name="category"
											{...register("category")}>
											<option>
												Distribución de materiales para la construcción.
											</option>
											<option>Distribución de carbón y leña.</option>
											<option>Distribución de electrodomésticos.</option>
											<option>Taxi Flet.</option>
											<option>Comisionista.</option>
											<option>Tanque atmosférico.</option>
											<option>Distribución de gas en garrafas.</option>
											<option>Servicios de mudanzas.</option>
											<option>Volquetes.</option>
											<option>Distribución de alimentos para mascotas.</option>
											<option>Distribución de muebles.</option>
											<option>Distribución de artículos de librería.</option>
											<option>Transporte de cargas generales.</option>
										</Form.Control>
									)}
								</Col>
							</Row>
						</Form.Group>
					</Card.Body>
				</Card>
				{bromatologico ? (
					<Card className="shadow mb-5 bg-white rounded">
						<Card.Header className="text-uppercase text-center">
							Declaración Jurada Bromatológica
						</Card.Header>

						<Card.Body>
							<Form.Group>
								<Row className="mb-2 text-uppercase ">
									<Col>
										Completá y firmá la siguiente
										<a
											target="blanck"
											download
											href="http://190.106.132.211/images/transpbrom/ddjj-brom.pdf">
											{" "}
											Declaración Jurada Bromatológica
										</a>
										<Form.File
											onInput={(e) => {
												handleFileExtensions(e);
												handleFileSizeMin(e);
											}}
											className="text-uppercase"
											name="declaration"
											label="adjuntá aquí la Declaración jurada firmada"
											custom
											accept="application/pdf,.jpg,.png"
											data-browse="Adjuntar"
											{...register("declaration")}
										/>
									</Col>
								</Row>
							</Form.Group>
						</Card.Body>
					</Card>
				) : null}
				{/* <Card className="shadow mb-5 bg-white rounded">
					<Card.Header className="text-uppercase text-center">
						Derecho de oficina
					</Card.Header>
					<Card.Body>
						<Form.Group>
							<Row className="mb-2 text-uppercase ">
								<Col>
									generá tu derecho por habilitación de autorización o permiso
									<>
										<Link
											variant="primary"
											onClick={() => ModalPayment(data?.codigo, setLoading)}>
											{"  "}aquí
										</Link>
									</>
									<Form.File
										onInput={(e) => {
											handleFileExtensions(e);
											handleFileSizeMin(e);
										}}
										className="text-uppercase"
										name="office"
										label="Adjuntá aquí el comprobante de pago"
										custom
										accept="application/pdf,.jpg,.png"
										data-browse="Adjuntar"
										{...register("office")}
									/>
								</Col>
							</Row>
						</Form.Group>
					</Card.Body>
				</Card> */}
				<Card className="shadow mb-5 bg-white rounded">
					<Card.Header className="text-uppercase text-center">
						Manipulación de Alimentos
					</Card.Header>
					<Card.Body>
						<Form.Group>
							<Row className="mb-2 text-uppercase ">
								<Col>
									carnet de Manipulación de Alimentos
									<Form.File
										onInput={(e) => {
											handleFileExtensions(e);
											handleFileSizeMin(e);
										}}
										className="text-uppercase"
										name="food"
										label="Adjuntá el documento"
										custom
										accept="application/pdf,.jpg,.png"
										data-browse="Adjuntar"
										{...register("food")}
									/>
								</Col>
							</Row>
						</Form.Group>
					</Card.Body>
				</Card>
				<div className="text-center">
					<Button
						type="submit"
						variant="outline-primary"
						className="p-2 pl-4 pr-4">
						ENVIAR SOLICITUD
					</Button>
				</div>
			</Form>
		</div>
	);
}
